import React, { Component } from "react";
import PropTypes from "prop-types";
import UserService from "../../../utils/keycloak/UserService";

class Login extends Component {
  static propTypes = {
    handleLogin: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    error: PropTypes.string,
    fromPasswordResetSuccess: PropTypes.bool,
  };

  static defaultProps = {
    isSubmitting: false,
    error: "",
    fromPasswordResetSuccess: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      token: "",
    };
  }

  // On load of the login page,
  // check if a user is already logged in, and load the state according
  // to the username and token coming from keycloak login session
  // UserService is a service class that handles the keycloak login

  componentDidMount() {
    if (UserService.isLoggedIn() && !UserService.isTokenExpired() && UserService.isUserAuthenticated()) {
      this.setState(() => ({
        username: UserService.getUsername(),
        token: UserService.getToken(),
      }));
      this.props.handleLogin(UserService.getUsername(), UserService.getToken());
    }
  }

  render() {
    return <></>;
  }
}

export default Login;
